<script>
import readXlsxFile, { Email } from "read-excel-file";
import FormModalMixin from '../../../../../../../src/components/share/modal/FormModalMixin'
import FormModal from '../form/SpreadsheetImport'
import api from '../../../../../../api'

export default {
  components: {
    FormModal
  },
  mixins: [
    FormModalMixin
  ],
  data() {
    return {
      title: 'Importuj Plik',
      okText: 'Importuj',
      usersFromFile: {},
      schema: {
        'imię': {
          prop: 'forename',
          type: String,
          required: true
        },
        'nazwisko': {
          prop: 'surname',
          type: String,
          required: true
        },
        'e-mail': {
          prop: 'email',
          type: Email,
          required: true
        },
        'telefon': {
          prop: 'phone',
          type: String,
          required: false
        }
      }

    }
  },
  methods: {
    redirectProperly() {
      let typeToSendMap = {
        main: 'main',
        main_vehicle: 'main',
        main_property: 'main',
        appraisal: 'appraisal'
      }
      this.$isWithClients(this.service)
        ? this.$router.push({ name: `${this.service}_${this.$route.meta.client}_${this.$route.meta.workflowName}_finance_import_invoice_${typeToSendMap[this.model.importTypeToSend]}` })
        : this.$router.push({ name: `${this.service}_${this.$route.meta.workflowName}_finance_import_invoice_${this.model.importTypeToSend}` })
    },
    getUsersFromFile() {
      return this.usersFromFile;
    },
    submitForm() {
      this.usersFromFile = {}
      this.$store.commit('SET_LOADING_USERS_IMPORT', true)
      if (this.model.file === undefined) {
        this.$notify({
          type: 'error',
          text: 'Brak wgranego pliku!'
        })

        this.$store.commit('SET_LOADING_USERS_IMPORT', false)
        return;
      }

      let xlsxfile = this.model.file ?? null;
      let schema = this.schema

      readXlsxFile(xlsxfile, { schema })
        .then(({ rows, errors }) => {

          try {
            if (errors.length > 0) {
              for (const e in errors) {
                this.$notify({
                  type: 'error',
                  text: errors[e].column + ' (wiersz: ' + errors[e].row + ') - [' + errors[e].error + '] ' + (errors[e].reason ?? '')
                })
              }
              return Promise.reject(new Error("Plik niepoprawny!"));
            }
          } catch (err) {
            this.$notify({
              type: 'error',
              text: 'error'
            })
          }

          const emails = rows.map(user => user.email);

          api.request('core', 'post', '/users/search', {
            contractor: false,
            format: "userBatch",
            indexBy: "email",
            searchCriteria: {
              searchBy: "email",
              values: emails
            }
          })
          .then((response) => {
            const responseData = response.data || response;

            rows.forEach((element, index) => {
              const userEmail = rows[index]['email'];

              if (responseData && userEmail in responseData) {
                  const userData = responseData[userEmail];

                  rows[index]['status'] = userData.status === 2 ? 'active' : 'inactive';
                  rows[index]['checked'] = false;
                  rows[index]['uuid'] = userData.uuid;
              } else {
                  rows[index]['status'] = 'new';
                  rows[index]['checked'] = true;
                  rows[index]['uuid'] = null;
              }

              this.usersFromFile[userEmail] = rows[index];
          });
          })
          .catch((error) => {
            this.$notify({
              type: 'error',
              text: error
            })
          })

          this.$emit('close')
          this.$root.$emit('importData', this.usersFromFile)
          this.$notify({
            type: 'success',
            text: 'Wczytano plik'
          })
        }).catch(() => {
          this.$notify({
            type: 'error',
            text: 'Brak pliku lub plik niepoprawny'
          })
        }).finally(() => {
          this.$store.commit('SET_LOADING_USERS_IMPORT', false)
        });
    }
  }
}
</script>
